import { API_BASE_URL } from '../config/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const executeRankCommand = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/slash-commands/rank`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to execute rank command');
    }

    return await response.json();
  } catch (error) {
    console.error('Rank command error:', error);
    throw error;
  }
};

export const executeAdsCommand = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/slash-commands/ads`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to execute ads command');
    }

    return await response.json();
  } catch (error) {
    console.error('Ads command error:', error);
    throw error;
  }
};

export const executeAnalyticsCommand = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/slash-commands/analytics`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to execute analytics command');
    }

    return await response.json();
  } catch (error) {
    console.error('Analytics command error:', error);
    throw error;
  }
};

export const executeCallsCommand = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/slash-commands/calls`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to execute calls command');
    }

    return await response.json();
  } catch (error) {
    console.error('Calls command error:', error);
    throw error;
  }
};

export const executeAuditCommand = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/slash-commands/audit`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to execute audit command');
    }

    return await response.json();
  } catch (error) {
    console.error('Audit command error:', error);
    throw error;
  }
};